import { render, staticRenderFns } from "./SiteContent.vue?vue&type=template&id=68cd5f3e"
import script from "./SiteContent.vue?vue&type=script&lang=js"
export * from "./SiteContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports